export const initialState = {
    titleEn: "",
    titleKr: "",
    titleZh: "",
    titleJp: "",
    descriptionEn: "",
    descriptionKr: "",
    descriptionJp: "",
    descriptionZh: "",
    imgPath: "",
    price: "",
    options: [],
    isStaffOnly: false,
};

export const columns = [
    {
        id: "titleEn",
        Header: "Title (EN)",
        accessor: "titleEn",
        sortable: true,
        filterable: true,
    },
    {
        id: "description",
        Header: "Description (EN)",
        accessor: "descriptionEn",
        sortable: true,
        filterable: true,
    },
    {
        id: "price",
        Header: "Price",
        accessor: "price",
        sortable: true,
        filterable: true,
    },
    {
        id: "category",
        Header: "Category",
        accessor: "category",
        sortable: true,
        filterable: true,
    },
    {
        id: "sequence",
        Header: "Sequence",
        accessor: "sequence",
        sortable: true,
        filterable: true,
    },
    {
        id: "actions",
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
    },
];
